import React, { Component } from 'react';
import { connect } from 'react-redux';

import materialTabService from '../../../../services/requests/material-tab.service';
import Spinner from '../../../../components/LoadingStyles/Spinner';
import './styles.scss';
import {
  setReinforcementEdge,
  setHoleConditions,
  setReinforcementLongTemp,
  setReinforcementShortTemp,
  setDrillingConditions,
  setReinforcementTension,
  setReinforcementShear
} from '@reducers/selectors/material/actions';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { standardList } from './../../../../app.values';

class ReinforcementAndConditions_ACI extends Component {

  static defaultProps = {
    options: {}
  };

  edges = [];
  tensions = [];
  shears = [];
  longTermTemps = [];
  shortTermTemps = [];
  conditions = [];
  conditionsAnchors = [];

  constructor(props) {
    super(props);
    this.fetchOptions();

    this.state = {
      isPending: true
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.temperatureUnit !== prevProps.temperatureUnit){
      Promise.all([
        materialTabService.getLongTermTemperature(),
        materialTabService.getShortTermTemperature()
      ])
      .then(([longTermTemps, shortTermTemps]) => {
        if (longTermTemps && longTermTemps.length > 0 && shortTermTemps && shortTermTemps.length > 0) {
          this.longTermTemps = longTermTemps;
          this.shortTermTemps = shortTermTemps;
          this.props.setReinforcementLongTemp(this.longTermTemps[0]['InternalName']);
          this.props.setReinforcementShortTemp(this.shortTermTemps[0]['InternalName']);
          this.forceUpdate(); // VladP: The arrays are not part of the state object, so we have to force an update
        }
      }); 
    }
  }

  fetchOptions() {
    Promise.all([
      materialTabService.getEdgeReinforcement(),
      materialTabService.getTensionLoadConditions(),
      materialTabService.getShearLoadConditions(),
      materialTabService.getLongTermTemperature(),
      materialTabService.getShortTermTemperature(),
      materialTabService.getHoleConditions(),
      materialTabService.getInstallationConditionsAnchors()
    ])
      .then(this.handleResponse)
      .then(
        this.unsetPending,
        this.unsetPending
      );
  }

  handleResponse = ([edges, tensions, shears, longTermTemps, shortTermTemps, conditions, conditionsAnchors]) => {
    this.edges = edges;
    this.tensions = tensions;
    this.shears = shears;
    this.longTermTemps = longTermTemps;
    this.shortTermTemps = shortTermTemps;
    this.conditions = conditions;
    this.conditionsAnchors = conditionsAnchors;

    if (this.shortTermTemps && 
      this.shortTermTemps.length > 0 &&
      !this.shortTermTemps.find(temp => temp['InternalName'] === this.props.chosenShortTermTemp))
      this.props.setReinforcementShortTemp(this.shortTermTemps[0]['InternalName']);

    if (this.longTermTemps &&
      this.longTermTemps.length > 0 && 
      !this.longTermTemps.find(temp => temp['InternalName'] === this.props.chosenLongTermTemp))
      this.props.setReinforcementLongTemp(this.longTermTemps[0]['InternalName']);
  };

  unsetPending = () => this.setState({ isPending: false });

  render() {
    return (
      <div className="calculation">
        { this.state.isPending && <Spinner /> }

        <section className="list-type">
          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_LABEL_EDGE_REINFORCEMENT.Content}</h4>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_EDGE_ICC.Content}>
          <select
            name="chosenEdge"
            className="form-control reinforcement__select"
            value={this.props.chosenEdge}
            onChange={e => this.props.setReinforcementEdge(e.target.value)}
          >
            {this.edges && this.edges.length && this.edges.map(n => (
              <option value={n['InternalName']} key={n['InternalName']} >{n['RunName']}</option>
            ))}
          </select>
          </Tooltip>

          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_LABEL_TENSSION_LOAD_CONDITIONS.Content}</h4>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_TENSION_LOAD_ICC.Content}>
          <select 
            className="form-control reinforcement__select"
            value={this.props.chosenTension}
            name="chosenTension"
            onChange={e => this.props.setReinforcementTension(e.target.value)}
          >
            {this.tensions && this.tensions.length && this.tensions.map(n => (
              <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
            ))}
          </select>
          </Tooltip>

          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_LABEL_SHEAR_LOAD_CONDITIONS.Content}</h4>
         <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_SHEAR_LOAD_ICC.Content}>
          <select
            className="form-control reinforcement__select"
            value={this.props.chosenShear}
            name="chosenShear"
            onChange={e => this.props.setReinforcementShear(e.target.value)}
          >
            {this.shears && this.shears.length && this.shears.map(n => (
              <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
            ))}
          </select>
          </Tooltip>
        </section>

        { Number(this.props.designStandard) !== standardList['ICC.Cast'] && (
          <section className="list-type">
            <p>{APP_TEXTS.MATERIAL_REINFORCEMENT_DESCRIPTION2.Content}</p>
            <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_SERVICE_TEMPERATURE_RANGE.Content}</h4>
            <p>{APP_TEXTS.MATERIAL_SERVICE_TEMPERATURE_RANGE_DESCRIPTION.Content}</p>

            <div>
              <label htmlFor="longTermTemperature"
              className="stand-off__label reinforcement__label">
              {APP_TEXTS.MATERIAL_LABEL_LONG_TERM_TEMPERATURE.Content}
              </label>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_LONG_TERM_TEMPERATURE.Content}>
              <select
                className="form-control reinforcement__select--small"
                value={this.props.chosenLongTermTemp}
                name="chosenLongTermTemp"
                onChange={e => this.props.setReinforcementLongTemp(e.target.value)}
              >
                {this.longTermTemps && this.longTermTemps.length && this.longTermTemps.map(n => (
                  <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
                ))}
              </select>
              </Tooltip>
            </div>

            <span>{APP_TEXTS.MATERIAL_LONG_TERM_TEMP_DESCRIPTION.Content}</span>
            <hr />

            <div>
              <label htmlFor="shortTermTemperature" 
              className="stand-off__label reinforcement__label">{APP_TEXTS.MATERIAL_LABEL_SHORT_TERM_TEMPERATURE.Content}</label>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_SHORT_TERM_TEMPERATURE.Content}>
              <select
                className="form-control reinforcement__select--small"
                value={this.props.chosenShortTermTemp}
                name="chosenShortTermTemp"
                onChange={e => this.props.setReinforcementShortTemp(e.target.value)}
              >
                {this.shortTermTemps && this.shortTermTemps.length && this.shortTermTemps.map(n => (
                  <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
                ))}
              </select>
              </Tooltip>
            </div>

            <span>{APP_TEXTS.MATERIAL_SHORT_TERM_TEMP_DESCRIPTION.Content}</span>
            <hr />

            <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_LABEL_INSTALLATION_CONDITIONS.Content}</h4>
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_INSTALLATION_CONDITIONS.Content}>
            <select
              name="chosenCondition"
              className="form-control reinforcement__select"
              value={this.props.chosenCondition}
              onChange={e => this.props.setHoleConditions(e.target.value)}
            >
              {this.conditions && this.conditions.length && this.conditions.map(n => (
                <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
              ))}
            </select>
            </Tooltip>
            
            <select
              name="installationConditionsAnchors"
              className="form-control reinforcement__select"
              value={this.props.chosenInstallationConditionsAnchors}
              onChange={e => this.props.setDrillingConditions(e.target.value)}
            >
              {this.conditionsAnchors && this.conditionsAnchors.length && this.conditionsAnchors.map(n => (
                <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
              ))}
            </select>
          
          </section>
        )}
      </div>
    );
  }

}

const mapState = state => {
  const {
    edge,
    longTemperature,
    shortTemperature,
    holeConditions,
    tension,
    shear,
    drillingConditions
  } = state.selectors.material[state.main.appType].reinforcementAndConditions;

  return {
    chosenEdge: edge,
    chosenTension: tension,
    chosenShear: shear,
    chosenLongTermTemp: longTemperature,
    chosenShortTermTemp: shortTemperature,
    chosenCondition: holeConditions,
    chosenInstallationConditionsAnchors: drillingConditions,
    designStandard: state.main.localization.designStandard,
    temperatureUnit: state.main.units.temperature
  };
};

const mapDispatch = dispatch => ({
  setReinforcementEdge: value => dispatch(setReinforcementEdge(value)),
  setReinforcementTension: value => dispatch(setReinforcementTension(window.parseInt(value))),
  setReinforcementShear: value => dispatch(setReinforcementShear(window.parseInt(value))),
  setReinforcementLongTemp: value => dispatch(setReinforcementLongTemp(value)),
  setReinforcementShortTemp: value => dispatch(setReinforcementShortTemp(value)),
  setHoleConditions: value => dispatch(setHoleConditions(value)),
  setDrillingConditions: value => dispatch(setDrillingConditions(value))
});

export default connect(mapState, mapDispatch)(ReinforcementAndConditions_ACI);



// WEBPACK FOOTER //
// ./src/views/Material/components/ReinforcementAndConditions/ReinforcementAndConditions_ACI.js